import {useEffect, useState} from "react";
import {Button, Col, Divider, Form, message, Radio, Row, Spin} from "antd";
import './style.scss'
import customerService from "../../service/customerService";
import {CustomerVerificationWrapperDto} from "../../dto/CustomerVerificationWrapperDto";
import {getUserInfo} from "../../security/KeyclockConfig";
import {CustomerVerificationScheduleDto} from "../../dto/CustomerVerificationScheduleDto";
import {CustomerVerificationTimeSlotsDto} from "../../dto/CustomerVerificationTimeSlotsDto";
import {useHistory} from "react-router-dom";
import {video_call_img} from '../../../AppImageConst';
import modal from "antd/es/modal";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {CustomerVerificationScheduleDayDto} from "../../dto/CustomerVerificationScheduleDayDto";
import {MSG_TOO_MANY_REQUESTS_ERROR} from "../../util/Messages";

const VideoAppointment = () => {
    const [dateSchedules, setDateSchedules] = useState<CustomerVerificationWrapperDto>();
    const [timeSchedules, setTimeSchedules] = useState<CustomerVerificationWrapperDto>();
    const [selectedDateSch, setSelectedDateSch] = useState('');
    const [isSpinnerLoad, setSpinnerLoad] = useState(false);

    const [selectedTimeSlot, setSelectedTimeSlot] = useState<CustomerVerificationTimeSlotsDto>({
        slotStart: '',
        slotEnd: '',
        taken: false,
        slotId: 0
    });
    const [userName, setUserName] = useState('');
    const history = useHistory();
    const [radioForm] = Form.useForm();
    useEffect(() => {
        getUserInfo().then((res: any) => {
            setUserName(res.preferred_username)
        });
        getDatesSchedule();
    }, [])
    const getDatesSchedule = () => {
        setSpinnerLoad(true)
        customerService.getDateScheduleForVerification().then(res => {
            setSpinnerLoad(false)
            if (res.data !== null) {
                setDateSchedules(res.data.results)
                getTimeSlots(res.data.results.verificationScheduleDtoList[0].actualDate)
                setSelectedDateSch(res.data.results.verificationScheduleDtoList[0].actualDate)
            } else {
                message.error("Schedule fetching failed").then();
            }
        }).catch(reason => {
            setSpinnerLoad(false)
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Schedule fetching failed").then();
            }
        })
    }
    const getTimeSlots = (selectedDate: string) => {
        setSpinnerLoad(true)
        setSelectedDateSch(selectedDate)
        radioForm.resetFields()
        customerService.getTimeScheduleForVerification(selectedDate).then(res => {
            setSpinnerLoad(false)
            if (res.data !== null) {
                setTimeSchedules(res.data.results)
            } else {
                message.error("Time slots fetching failed").then();
            }
        }).catch(reason => {
            setSpinnerLoad(false)
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Time slots fetching failed").then();
            }
        })
    }

    const submitData = () => {

        if (selectedTimeSlot.slotStart == "") {
            message.warning("Please select a time slot!")
        } else {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                className: 'confirm-dialog-box',
                content: `Are you sure you want to submit the time slot?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    setSpinnerLoad(true)
                    let customerVerificationDto: CustomerVerificationScheduleDto = {
                        requestedDate: selectedDateSch,
                        requestedStartTime: selectedTimeSlot.slotStart,
                        requestedEndTime: selectedTimeSlot.slotEnd,
                        videoSlotId: selectedTimeSlot.slotId
                    }
                    customerService.saveCustomerVerificationSchedule(userName, customerVerificationDto).then(res => {
                        message.success("Schedule submitted successfully").then(() => {
                            setSpinnerLoad(false)
                            history.push('/workflow/customer/dashboard')
                        });
                    }).catch(reason => {

                        if ("" == reason.response.data){
                            if (429 == reason.response.status){
                                setSpinnerLoad(false)
                                message.error(MSG_TOO_MANY_REQUESTS_ERROR).then()
                            }else {
                                setSpinnerLoad(false)
                                message.error("Submit failed").then();
                            }
                        }else if (reason.response?.data?.errors.length) {
                            setSpinnerLoad(false)
                            message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
                        } else {
                            setSpinnerLoad(false)
                            message.error("Submit failed").then();
                        }
                    })
                },
            });

        }
    }
    const onClickDateSchBtn=(data:CustomerVerificationScheduleDayDto)=>{
        getTimeSlots(data.actualDate)
        setSelectedTimeSlot({
            slotStart: '',
            slotEnd: '',
            taken: false,
            slotId: 0
        })
    }
    return (
        <Spin spinning={isSpinnerLoad} tip="Loading" size="large">
            <div className='video_call_main_screen'>
                <Row gutter={0} className='main-row'>
                    <Col lg={12} md={{span: 0}} sm={{span: 0}} hidden className='left-side-main-container'>
                        <Row gutter={0} className='main-row'>
                            <Col span={24}>
                                <div className="clip-path-img">
                                    <div className='clip-path-img-container'>
                                        <img style={{height: 185}} src={video_call_img} alt="logo"/>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24} className='left-side-title-container'>
                                <h1 className='left-side-main-title'>Let’s make an appointment
                                    for your video verification</h1>
                                {/*<h1 className='left-side-main-title'>YOUR WEALTH</h1>*/}
                                <div className="header_divider"></div>
                                <h2 className='left-side-sub-title'>Securely book your personalized video verification
                                    appointment
                                    and complete the verification process at your convenience.</h2>
                                {/*<h2 className='left-side-sub-title'>No stress</h2>*/}
                            </Col>
                        </Row>

                    </Col>
                    <Col lg={12} md={24} sm={24} className='right-side-col'>
                        <div>
                            <div className="right_side_container">
                                <h1 className='main-header'>Make an Appointment</h1>
                                <h5 className='sub-header'>Easily select a preferred date and time for your video
                                    verification appointment</h5>
                                <Row gutter={32} style={{marginBottom: 4,}} className='dates-row'>
                                    {
                                        dateSchedules?.verificationScheduleDtoList.map((data, index) => {
                                            return <Col lg={8} sm={8} md={8} xs={8} className='dates-col' key={index}>
                                                <Button type="primary"
                                                        className={selectedDateSch == data.actualDateString ? "btn-select-color" : "btn-unselect-color"}
                                                        onClick={()=>onClickDateSchBtn(data)}
                                                >
                                                    <div className='date-btn-container'>
                                                        <span className='month-data'>{data.displayMonth}</span>
                                                        <span className='date-data'>{data.displayDate}</span>
                                                        <span className='year-data'>{data.displayYear}</span>
                                                    </div>
                                                </Button>
                                            </Col>
                                        })
                                    }
                                </Row>

                                <Row>
                                    <Col span={24}>
                                        <Divider/>
                                    </Col>
                                </Row>
                                <Form
                                    // className='form-input attachments-upload-form'
                                    layout={"vertical"}
                                    form={radioForm}
                                >
                                    <Form.Item name={"abc"}>
                                        <Row style={{marginTop: 4}}>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='times-col custom_height_for_time_slot'>
                                                <Radio.Group buttonStyle="solid" size="large"
                                                >
                                                    {
                                                        timeSchedules?.verificationTimeSlotsDtoList.map((data, index) => {
                                                            return <Radio.Button disabled={data.taken}
                                                                                 key={index}
                                                                                 onClick={() => setSelectedTimeSlot(data)}
                                                                                 value={index}>
                                                                {data.slotStart} - {data.slotEnd}</Radio.Button>
                                                        })
                                                    }

                                                </Radio.Group>
                                            </Col>

                                        </Row>
                                    </Form.Item>
                                </Form>
                                <Row gutter={[16, 0]}>
                                    <Col lg={12} md={12} xl={12} sm={12} xs={12} className='back-btn-container'>
                                        <Form.Item className='form-item-btn'>
                                            <Button className='custom-back-btn-primary' type="ghost"
                                                    onClick={() => history.push('/create-individual-account')}>
                                                Back
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12} md={12} xl={12} sm={12} xs={12} className='continue-btn-container'>
                                        <Form.Item className='form-item-btn'>
                                            <Button className='custom-btn-primary' type="primary" htmlType="submit"
                                                    onClick={submitData}>
                                                Continue
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>

                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Spin>
    )

}
export default VideoAppointment;

